import { AnalyzeError } from "#modules/quoteRequestLines/AnalyzeError";

type Props = {
  errorText: string;
  retryText: string;
  openDetailsPanel: () => void;
};

export const LowConfidenceState = ({ errorText, retryText, openDetailsPanel }: Props) => {
  return (
    <AnalyzeError errorText={errorText} retryText={retryText} retryAction={openDetailsPanel} />
  );
};
